// Copyright (c) 2020 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleError} from '../../../shared/services/error-handlers';

const basePath = '/api';

export async function getSpaClaims(payload) {

    const endPoint = (payload.export === 'EXCEL') ? `${basePath}/claims-for-approval-summaries/collection?export=EXCEL&tabm=true` : `${basePath}/claims-for-approval-summaries/collection?tabm=true`;

    const fetchOptions = {
        body: JSON.stringify(payload),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return (payload.export === 'EXCEL') ? response : response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getSpaClaim(claimNumber) {

    const endPoint = `${basePath}/claims-for-approval/${claimNumber}/tabm`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function updateSpaClaim(claimForApproval) {

    const endPoint = `${basePath}/claims-for-approval/${claimForApproval.claimNumber}`;

    const fetchOptions = {
        body: JSON.stringify(claimForApproval),
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

export async function getTabmSettings(userId) {

    const endPoint = `${basePath}/users/${userId}/tabm`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}



// WEBPACK FOOTER //
// ./src/tabm/shared/repositories/index.js